import LoadingPage from '@innovyze/stylovyze/lib/components/LoadingPage';
import React from 'react';
export default function RenderComponentOrLoading({ loading, children, }) {
    return loading ? React.createElement(LoadingPage, null) : React.createElement(React.Fragment, null, children);
}
